import { Grid, IconButton, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import Visibility from '@mui/icons-material/Visibility'; 
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import styles from './styles'; 

const Input = ({half, name, label, handleChange, autoFocus, handleShowPassword, type, error, helperText}) => {


    return (

        <TextField 
            name={name}
            onChange={handleChange}
            variant='outlined'
            type={type}
            required
            fullWidth
            error={error}
            helperText={helperText}
            label={label}
            autoFocus={autoFocus}
            sx={styles.textField}
            InputProps={name === 'password' || name === 'confirmPassword' ? {
                    endAdornment: (
                        <InputAdornment position='end'>
                            <IconButton onClick={handleShowPassword}>
                                {type === 'password' ? 
                                    <Visibility /> 
                                    :
                                    <VisibilityOff />
                                }
                            </IconButton>
                        </InputAdornment>
                    ),
                }
                : null
            }
        /> 
        
        
    );
}

export default Input; 